module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/anatomy-babelrc.json
// module id = 1948
// module chunks = 180904998783293